// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1jZwc","primary":"Button_primary__2Qh5q","success":"Button_success__2Ovlu","error":"Button_error__1fxXL"};